import type { Localization, SelectedParameter } from '../../../hooks/store/useAppStore.ts';

export type GeneratedLabel = {
  specimenId: string;
  testTubeId: string;
  testTubeName: string;
  testTubeColor: string;
  testTubeLabelText: string;
  location: string;
  repetition: number;
  specialPrinterRequired: boolean;
};

/** this is more or less the same logic as in the backend but without the label runningNumber */
export const generateLabels = (selectedParams: SelectedParameter[], localizations: Localization[]): GeneratedLabel[] => {
  const labels: GeneratedLabel[] = [];
  for (const selectedParam of selectedParams) {
    for (const specimen of selectedParam.specimens) {
      for (const testTube of specimen.testTubes) {
        if (specimen.requiresLocalizations) {
          for (const localization of localizations.filter(it => it.specimenId === specimen.id && it.paramId === selectedParam.id)) {
            if (
              !labels.some(it => it.specimenId === specimen.id && it.testTubeId === testTube.id && it.location === localization.location)
            ) {
              labels.push({
                specimenId: specimen.id,
                testTubeId: testTube.id,
                testTubeName: testTube.name,
                testTubeColor: testTube.color,
                testTubeLabelText: testTube.labelText,
                location: localization.location,
                repetition: 0,
                specialPrinterRequired: testTube.specialPrinterRequired,
              });
            }
          }
        } else {
          let numLabels = 1;

          if (testTube.volume > 0) {
            const sumParamVolumes = selectedParams
              .filter(p => p.specimens.some(s => s.id === specimen.id && s.testTubes.some(tt => tt.id === testTube.id)))
              .reduce((sum, current) => sum + current.volume, 0);

            if (sumParamVolumes > 0) {
              numLabels = Math.ceil(sumParamVolumes / testTube.volume);
            }
          }

          for (let i = 0; i < numLabels; i++) {
            if (!labels.some(it => it.specimenId === specimen.id && it.testTubeId === testTube.id && it.repetition === i)) {
              labels.push({
                specimenId: specimen.id,
                testTubeId: testTube.id,
                testTubeName: testTube.name,
                testTubeColor: testTube.color,
                testTubeLabelText: testTube.labelText,
                location: '',
                repetition: i,
                specialPrinterRequired: testTube.specialPrinterRequired,
              });
            }
          }
        }
      }
    }
  }
  return labels;
};
